import { Injectable, OnDestroy } from "@angular/core";
import { Event } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class CustomerTableI18n implements OnDestroy {

	private m_subscriptionsSubject = new Subject();

	public customerTableCustomerRemove: string = "";

	constructor(
		private m_translateService: TranslateService
	) {
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	private getAndInitTranslations(): void {
		this.m_translateService.get('CUSTOMER.TABLE.CUSTOMER_REMOVE.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.customerTableCustomerRemove = res;
			}
		});
	}
}
